// auth 플러그인 — 공용 플랫폼 호스팅 로그인 (prd/112 FR-002·FR-008)
// 로그인 화면·소셜 제공자는 플랫폼에 있다. 이 플러그인은 유저를 보내고, 돌아온 토큰을 받아 코어 세션(ports/session.ts)에 넣는다.
// MVP API 는 그 토큰을 플랫폼 공개키로 검증한다(api/internal/platform) — 이 MVP 에 로그인용 비밀값은 없다
import { z } from 'zod';

import { definePlugin } from '../../composition/plugin-runtime';
import { MVP_NAME, PLATFORM_URL } from '../../ports/platform';
import { SLOT_KEYS } from '../../ports/slots';
import { startAuth, stopAuth } from './composition/auth';
import { AuthWidget } from './presentation/auth-widget';

export default definePlugin({
  name: 'auth',
  version: '0.1.0',
  params: z.object({
    /** 플랫폼 공인 주소 — 로컬에서 플랫폼을 띄웠을 때만 composition/plugin-config.ts 에서 덮는다 */
    platformUrl: z.url(),
    /** 플랫폼에 등록된 이 MVP 의 이름 */
    tenant: z.string().min(1),
    /** 로그인 위젯을 그릴 자리 — 기본은 홈, 머리말에 두려면 app.header */
    slot: z.enum(SLOT_KEYS),
  }),
  defaults: { params: { platformUrl: PLATFORM_URL, tenant: MVP_NAME, slot: 'home.main' } },
  setup(ctx, params) {
    ctx.messages('ko', { label: '로그인', login: '로그인', logout: '로그아웃', signedIn: '로그인했어요' });
    ctx.messages('en', { label: 'Sign in', login: 'Sign in', logout: 'Sign out', signedIn: 'Signed in' });
    ctx.slot(params.slot, AuthWidget, { priority: 10 });
    startAuth(params);
  },
  dispose: stopAuth,
});
